import { motion } from "framer-motion";
import {
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
} from "react-icons/fa";
import { HiMail } from "react-icons/hi";
import { ArrowUpRight, ShieldCheck } from "lucide-react";
import logo from "../Assest/newcluster.png";
import "../Styles/Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* CTA */}
        <motion.div
          className="footer-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="footer-eyebrow">
            READY TO SHARE YOUR BUSINESS?
          </p>

          <h2 className="footer-title">
            Wear your business.
            <br />
            <span>Everywhere you go.</span>
          </h2>

          <a href="/product" className="footer-button">
            Get your wristband
            <ArrowUpRight size={18} />
          </a>
        </motion.div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Footer Grid */}
        <div className="footer-grid">

          {/* Brand */}
          <div className="footer-brand">
            <img
              src={logo}
              alt="ClusterClear"
              className="footer-logo"
            />

            <p className="footer-tagline">
              The smart NFC wristband that instantly shares your
              Instagram, WhatsApp, website, contact details and more
              with one simple tap.
            </p>
          </div>

          {/* Product */}
          <div className="footer-column">
            <h4>Product</h4>

            <a href="/#how-it-works">
              How it works
            </a>

            <a href="/#reviews">
              Reviews
            </a>

            <a href="/#faq">
              FAQs
            </a>

            <a href="/product">
              Get your wristband
            </a>
          </div>

          {/* Company */}
          <div className="footer-column">
            <h4>Company</h4>

            <a href="/#contact-us">
              Contact
            </a>

            <a href="/privacy">
              Privacy Policy
            </a>

            <a href="/terms">
              Terms & Conditions
            </a>

            <a href="/cookies">
              Cookies
            </a>
          </div>

          {/* Social */}
          <div className="footer-column">
            <h4>Follow us</h4>

            <a
              href="https://instagram.com/clusterclear_01"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social"
            >
              <FaInstagram />
              Instagram
            </a>

            <a
              href="https://tiktok.com/@clusterclear"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social"
            >
              <FaTiktok />
              TikTok
            </a>

            <a
              href="mailto:support@clusterclear.com"
              className="footer-social"
            >
              <HiMail />
              Email
            </a>

            <a
              href="https://wa.me/+447944173072"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-social"
            >
              <FaWhatsapp />
              WhatsApp
            </a>
          </div>

        </div>

        {/* Bottom */}
        <div className="footer-bottom">

          <div className="footer-secure">
            <ShieldCheck size={16} />
            <span>
              Secure NFC technology. No battery. No app required.
            </span>
          </div>

          <p className="footer-copy">
            © {year} ClusterClear. All rights reserved.
          </p>

        </div>

      </div>
    </footer>
  );
};

export default Footer;